import {useQuery} from "@tanstack/react-query";
import {useSelector} from "react-redux";
import {getData} from "../../../app/getters/getData.js";

export const useHistoriaSprawozdanie = (rejestrId, enabled = true) => {

    const role = useSelector(state => state.user.role)
    const roleParam = role === 'oper' ? 'oper/' : '/'
    const endpoint = `${roleParam}sprawozdanie/historia/${rejestrId}`;

    return useQuery({
        queryKey: [`historia_sprawozdanie`, rejestrId],
        queryFn: () => getData(endpoint),
        enabled: enabled,
        refetchOnMount: true,
    })
}
